import {connect} from 'react-redux';
import {useAppSelector, useAppDispatch} from '../../app/hooks';
import {apiRequest, loginRequest} from '../../authConfig';
import {useMsal} from '@azure/msal-react';
import {getProfileAsync} from './profileSlice';
import {useEffect} from 'react';
import {setActiveLink} from '../navmenu/navbarSlice';
import {Row, Card, Form} from 'react-bootstrap';

export const Profile = () => {
    const {instance, accounts} = useMsal();
    const dispatch = useAppDispatch();
    const profile = useAppSelector((state) => state.profile.profile);


    useEffect(() => {
        const requestApiAccessToken = async (): Promise<string> => {
            const request = {
                ...apiRequest,
                account: accounts[0],
            };

            try {
                const response = await instance.acquireTokenSilent(request);
                return response.accessToken;
            } catch (error) {
                const response = await instance.acquireTokenSilent(request);
                return response.accessToken;
            }
        };

        const loadData = async () => {
            const apiToken = await requestApiAccessToken();
            // const claims: Keyable | undefined = accounts[0].idTokenClaims;

            dispatch(
                getProfileAsync({
                    apiToken: apiToken,
                    // accountId: claims && claims.oid,
                })
            );
        };
        dispatch(setActiveLink(''));
        loadData();
    }, [accounts, dispatch, instance]);

    return (
        <Card>
            <Card.Header as="h2" className="text-center">
                Profile
            </Card.Header>
            <Card.Body>
                <Form>
                    <fieldset disabled>
                        <Row className="mb-3">
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="givenName">Given name</Form.Label>
                                <Form.Control 
                                    id="givenName"
                                    readOnly
                                    value={profile?.givenName ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="sureName">Surename</Form.Label>
                                <Form.Control
                                    id="sureName"
                                    readOnly
                                    value={profile?.surname ?? ''}
                                />
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="displayName">Display name</Form.Label>
                                <Form.Control
                                    id="displayName"
                                    readOnly
                                    value={profile?.displayName ?? ''}
                                />
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="streetAddress">Street address</Form.Label>
                                <Form.Control
                                    id="streetAddress"
                                    readOnly
                                    value={profile?.streetAddress ?? ''}
                                />
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="city">City</Form.Label>
                                <Form.Control 
                                    id="city"
                                    readOnly
                                    value={profile?.city ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="country">Country</Form.Label>
                                <Form.Control 
                                    id="country"
                                    readOnly
                                    value={profile?.country ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="email">Email</Form.Label>
                                <Form.Control 
                                    id="email"
                                    readOnly
                                    value={profile?.mail ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="companyName">Company name</Form.Label>
                                <Form.Control 
                                    id="companyName"
                                    readOnly
                                    value={profile?.companyName ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="jobTitle">Job title</Form.Label>
                                <Form.Control 
                                    id="jobTitle"
                                    readOnly
                                    value={profile?.jobTitle ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="mobilePhone">Phone</Form.Label>
                                <Form.Control 
                                    id="mobilePhone"
                                    readOnly
                                    value={profile?.mobilePhone ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="preferredLanguage">Preferred language</Form.Label>
                                <Form.Control 
                                    id="preferredLanguage"
                                    readOnly
                                    value={profile?.preferredLanguage ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="usageLocation">User location</Form.Label>
                                <Form.Control 
                                    id="usageLocation"
                                    readOnly
                                    value={profile?.usageLocation ?? ''}/>
                            </Form.Group>
                            <Form.Group className="col-lg-6 col-md-12 mb-3">
                                <Form.Label htmlFor="userType">User type</Form.Label>
                                <Form.Control 
                                    id="userType"
                                    readOnly
                                    value={profile?.userType ?? ''}/>
                            </Form.Group>
                        </Row>
                    </fieldset>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default connect()(Profile);
